import { ErrorImage } from '../../../ErrorImage'

export function Error404Image() {
  return <ErrorImage src="/images/404.png" alt="Error-404" />
}
